import { ModelBase } from 'store/model-base';

export class CmsDevices extends ModelBase {
    public static storeName: string = 'cmsDevices';

    public landing: CmsDevicesLanding;
    public detail: CmsDevicesDetail;
    public damagePhone: CmsDamagePhone;
    public protection: CmsProtection;
    public xmcProtection: CmsProtection;
    public xtdProtection: CmsProtection;
    public xtdProtectionPlus: CmsProtection;
    public fccLineLock: CmsFccLineLock;
    public xfinityMobileCarePlanEightResi: CmsProtection;
    public xfinityMobileCarePlusPlanEightResi: CmsProtection;
    public xfinityMobileCarePlusNYPlanEightResi: CmsProtection;
}
